import styled from '@emotion/styled';
import { CommonBG, CommonBorder, ControlFilldBG } from 'ui/theme/Color';

export const SummaryItem = styled.div`
  // padding: 12px 16px;
  min-width: 0;
  height: 100%;
  // border: 1px solid ${CommonBorder.Basic};
  // .title {
  //     margin-bottom: 12px;
  //     font-size: 16px;
  //     font-weight: 600;
  //     font-family: "Spoqa Han Sans Neo";
  //     display: flex;
  // }
  .listScroll {
    height: calc(100% - 30px);
    min-height: 180px;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .gridHeight {
    height: calc(100% - 30px);
    min-height: 230px;
  }

  &.tabContents {
    position: relative;
    grid-row: 1 / span 2;
    & > div.tabpanel-area {
      height: calc(100% - 56px);
      > div {
        height: 100%;
      }
    }
  }

  &.Schedule {
    .listScroll {
      overflow: hidden;
      overflow-y: auto;
      padding: 12px;
      // background: ${CommonBG.Deep};
      box-sizing: border-box;
      max-height: calc(100vh - 740px);
      ul > li {
        font-size: 13px;
      }
    }
  }
  &.dashboard {
    .tableScroll {
      // border-bottom: 1px solid ${CommonBorder.Strong};
      overflow: hiddne;
      overflow-y: auto;
      height: 230px;
    }
  }
`;

export const ListItem = styled.div`
  &:not(:last-child) {
    padding-bottom: 6px;
    border-bottom: 1px dashed ${CommonBorder.Basic};
  }

  h4 {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
  }
  ul {
    display: table;
    li {
      display: table-row;
      gap: 12px;
      margin-bottom: 4px;
      font-size: 12px;
      * {
        display: table-cell;
        padding: 1px 12px;
        &:first-child {
          padding-left: 0;
        }
      }
    }
  }
`;
